/**
 * @author 仇兴洲
 * @description 校验工具
 */
const validate = {}

/**
 * @description 对Element ui多个表单进行校验
 * @param {Array} formArray 表单数组
 * @param {Function} callback 回调函数
 * @param {Boolean} isAutoScroll 是否滚动到校验错误的元素
 */
validate.formValidate = function (formArray = [], callback = () => {}, isAutoScroll = true) {
  return Promise.all(
    formArray.map((form) => {
      return new Promise((resolve) => {
        form.validate((res) => {
          resolve(res)
        })
      })
    })
  )
    .then((res) => {
      const valid = res.every((item) => !!item)
      callback(valid)
      if (!valid && isAutoScroll) {
        for (let i = 0; i < res.length; i++) {
          if (!res[i]) {
            const isError = formArray[i].$el.getElementsByClassName('is-error')
            isError[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            })
            break
          }
        }
      }
      return valid
    })
    .catch((err) => {
      console.log(err)
    })
}

export default validate
